import React from 'react';
import { Link } from 'react-router-dom';
import { Server, Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Globe } from 'lucide-react';
import { getStorageUrl } from '../../utils/imageUrlUpdater';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <div className="flex items-center mb-4">
              <img src={getStorageUrl('logo/logovmon.png')} alt="VMON" className="h-8 w-auto" />
            </div>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2 mt-1"><i className="fas fa-city"></i></span>
                <span>CÔNG TY TNHH CÔNG NGHỆ DỊCH VỤ VMON</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2 mt-1"><i className="fas fa-map-marked-alt"></i></span>
                <span>Tầng 6, Tòa nhà G3, VINHOMES GREENBAY, SỐ 7, ĐCT08, Mễ Trì, Nam Từ Liêm, Hà Nội</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2 mt-1"><i className="fas fa-envelope-open-text"></i></span>
                <span>support [at] vmon.vn</span>
              </li>
              <li className="flex items-start">
                <a href="tel:0966805315" className="flex items-center text-gray-600 hover:text-blue-500">
                  <span className="text-blue-500 mr-2"><i className="fas fa-headset"></i></span>
                  <span>0966.805.315</span>
                </a>
              </li>
            </ul>
            <h4 className="text-lg font-medium text-gray-900 mt-6 mb-4">Theo Dõi Chúng Tôi</h4>
            <div className="flex space-x-2">
              <a href="https://www.facebook.com/VMonCloud" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md text-gray-500 hover:text-blue-500 hover:border-blue-500 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://zalo.vmon.vn/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md text-gray-500 hover:text-blue-500 hover:border-blue-500 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 460.1 436.6" width="24" height="24" fill="currentColor">
                  <path d="M82.6 380.9c-1.8-.8-3.1-1.7-1-3.5 1.3-1 2.7-1.9 4.1-2.8 13.1-8.5 25.4-17.8 33.5-31.5 6.8-11.4 5.7-18.1-2.8-26.5C69 269.2 48.2 212.5 58.6 145.5 64.5 107.7 81.8 75 107 46.6c15.2-17.2 33.3-31.1 53.1-42.7 1.2-.7 2.9-.9 3.1-2.7-.4-1-1.1-.7-1.7-.7-33.7 0-67.4-.7-101 .2C28.3 1.7.5 26.6.6 62.3c.2 104.3 0 208.6 0 313 0 32.4 24.7 59.5 57 60.7 27.3 1.1 54.6.2 82 .1 2 .1 4 .2 6 .2H290c36 0 72 .2 108 0 33.4 0 60.5-27 60.5-60.3v-.6-58.5c0-1.4.5-2.9-.4-4.4-1.8.1-2.5 1.6-3.5 2.6-19.4 19.5-42.3 35.2-67.4 46.3-61.5 27.1-124.1 29-187.6 7.2-5.5-2-11.5-2.2-17.2-.8-8.4 2.1-16.7 4.6-25 7.1-24.4 7.6-49.3 11-74.8 6zm72.5-168.5c1.7-2.2 2.6-3.5 3.6-4.8 13.1-16.6 26.2-33.2 39.3-49.9 3.8-4.8 7.6-9.7 10-15.5 2.8-6.6-.2-12.8-7-15.2-3-.9-6.2-1.3-9.4-1.1-17.8-.1-35.7-.1-53.5 0-2.5 0-5 .3-7.4.9-5.6 1.4-9 7.1-7.6 12.8 1 3.8 4 6.8 7.8 7.7 2.4.6 4.9.9 7.4.8 10.8.1 21.7 0 32.5.1 1.2 0 2.7-.8 3.6 1-.9 1.2-1.8 2.4-2.7 3.5-15.5 19.6-30.9 39.3-46.4 58.9-3.8 4.9-5.8 10.3-3 16.3s8.5 7.1 14.3 7.5c4.6.3 9.3.1 14 .1 16.2 0 32.3.1 48.5-.1 8.6-.1 13.2-5.3 12.3-13.3-.7-6.3-5-9.6-13-9.7-14.1-.1-28.2 0-43.3 0z"></path>
                </svg>
              </a>
              <a href="https://t.me/VMonCloud" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md text-gray-500 hover:text-blue-500 hover:border-blue-500 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@VMonCloud" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md text-gray-500 hover:text-blue-500 hover:border-blue-500 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/vmoncloud/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md text-gray-500 hover:text-blue-500 hover:border-blue-500 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                </svg>
              </a>
            </div>
            <div className="mt-4">
              <a href="//www.dmca.com/Protection/Status.aspx?id=b4143090-a894-489a-86f5-79034f5a617d" title="DMCA.com Protection Status" target="_blank" rel="noopener noreferrer">
                <img src="https://images.dmca.com/Badges/dmca_protected_sml_120aj.png?ID=b4143090-a894-489a-86f5-79034f5a617d" alt="DMCA.com Protection Status" />
              </a>
            </div>
          </div>

          {/* Thông Tin */}
          <div className="col-span-1">
            <h4 className="text-lg font-medium text-gray-900 mb-4">Thông Tin</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/gioi-thieu" className="text-gray-600 hover:text-blue-500">
                  Giới Thiệu
                </Link>
              </li>
              <li>
                <Link to="/lien-he" className="text-gray-600 hover:text-blue-500">
                  Liên Hệ
                </Link>
              </li>
              <li>
                <Link to="/dieu-khoan-su-dung" className="text-gray-600 hover:text-blue-500">
                  Điều Khoản
                </Link>
              </li>
            </ul>
          </div>

          {/* Dịch Vụ */}
          <div className="col-span-1">
            <h4 className="text-lg font-medium text-gray-900 mb-4">Dịch Vụ</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/vps-us" className="text-gray-600 hover:text-blue-500">
                  VPS US - Mỹ
                </Link>
              </li>
              <li>
                <Link to="/vps-singapore" className="text-gray-600 hover:text-blue-500">
                  VPS Singapore
                </Link>
              </li>
              <li>
                <Link to="/vps-australia" className="text-gray-600 hover:text-blue-500">
                  VPS Australia
                </Link>
              </li>
              <li>
                <Link to="/vps-chau-au" className="text-gray-600 hover:text-blue-500">
                  VPS Châu Âu
                </Link>
              </li>
              <li>
                <Link to="/vps-canada" className="text-gray-600 hover:text-blue-500">
                  VPS Canada
                </Link>
              </li>
              <li>
                <Link to="/vps-viet-nam" className="text-gray-600 hover:text-blue-500">
                  VPS Việt Nam
                </Link>
              </li>
              <li>
                <Link to="/vps-forex" className="text-gray-600 hover:text-blue-500">
                  VPS Forex
                </Link>
              </li>
              <li>
                <Link to="/vps-windows" className="text-gray-600 hover:text-blue-500">
                  VPS Windows
                </Link>
              </li>
              <li>
                <Link to="/thue-may-chu" className="text-gray-600 hover:text-blue-500">
                  Máy Chủ Vật Lý
                </Link>
              </li>
            </ul>
          </div>

          {/* Hữu Ích */}
          <div className="col-span-1">
            <h4 className="text-lg font-medium text-gray-900 mb-4">Hữu Ích</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/docs" className="text-gray-600 hover:text-blue-500">
                  Tài Liệu
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-blue-500">
                  Blog
                </Link>
              </li>
              <li>
                <a href="/category/thong-bao" className="text-gray-600 hover:text-blue-500">
                  Thông báo
                </a>
              </li>
              <li>
                <a href="/category/huong-dan-su-dung-vmon-cloud" className="text-gray-600 hover:text-blue-500">
                  Hướng dẫn sử dụng
                </a>
              </li>
              <li>
                <a href="/kiem-tien-cung-vmon-cloud-7376" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-500">
                  Affiliate
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-gray-600 text-sm text-center">
            Copyright © 2025. All Rights Reserved To VMon Cloud.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;